export class Requester {
    call({endpoint, data = undefined}) {
        throw new Error("You have to implement the method");
    }
}
